// import * as Vue from 'vue'
import md5 from 'blueimp-md5'
import { callIosApp } from './call-app'
import qs from 'qs'
import { exts } from './constants'

// 安全转码成中文
export function decodeToCn(str) {
  let name = ''
  try {
    name = decodeURIComponent(str)
  } catch (_) {
    return unescape(str)
  }
  return name
}

/**
 * 获取客户端版本
 */
export function getThunderVersion(userAgent = typeof window !== 'undefined' && window.navigator.userAgent) {
  const matcher = /Thunder\/([^ ]*)/.exec(userAgent)

  return {
    thunder: matcher && matcher[1],
    thunderComponent: null,
  }
}

/**
 * 将一个支持callback的函数转换成支持promise的
 * @method promisefy
 * @param {Function} fn - 支持callback的函数
 * @param {Object} context - 执行环境
 * @returns {Function}
 */
export function promisefy(fn, context) {
  return function (...args) {
    return new Promise((resolve, reject) => {
      const cb = (err, payload) => {
        if (err) {
          reject(err)
        } else {
          resolve(payload)
        }
      }
      fn.apply(context, [...args, cb])
    })
  }
}

export function promisefyCheck(fn, context) {
  return function (...args) {
    return new Promise((resolve, reject) => {
      const cb = payload => {
        resolve(payload)
      }
      fn.apply(context, [...args, cb])
    })
  }
}

/**
 * 设置cookie
 * @author @zhaobing
 * @param {String} key
 * @param {String} value
 * @param {Object} opt
 * @property {String} opt.path - 例如 '/', '/mydir') 如果没有定义，默认为'/'。
 * @property {String} opt.domain - (例如 'example.com'， '.example.com' (包括所有子域名),
 *  'subdomain.example.com') 如果没有定义，默认为当前文档位置的路径的域名部分。
 * @property {String} opt.maxAge - max-age-in-seconds (例如一年为60*60*24*365)
 * @property {String} opt.expires - 过期时间，不需要转换成UTC
 * @property {String} opt.secure - cookie只通过https协议传输，默认为false
 */
export function setCookie(key, value, { path = '/', domain, maxAge, expires, secure } = {}) {
  let cookieStr = key + '=' + encodeURIComponent(value)

  path && (cookieStr += ';path=' + path)
  domain && (cookieStr += ';domain=' + domain)
  maxAge && (cookieStr += ';max-age=' + maxAge)
  expires && (cookieStr += ';expires=' + expires.toUTCString())
  secure && (cookieStr += ';secure=' + secure)

  document.cookie = cookieStr
}

/**
 * @method getCookie
 * @desc 获取cookie值
 * @param name {String} - cookie字段名
 * @returns {String} - cookie值
 */
export function getCookie(name, cookie = '') {
  if (!cookie && process.client) {
    cookie = document.cookie
  }
  const result = cookie.match(new RegExp('(^' + name + '| ' + name + ')=([^;]*)')) == null ? '' : RegExp.$2

  return result
}

/***
 * 删除cookie中指定变量函数
 * @param {string} name Cookie名称
 */
export function deleteCookie(name) {
  const myDate = new Date()
  myDate.setTime(-1000) // 设置时间
  document.cookie = name + "=''; expires=" + myDate.toGMTString()
  document.cookie = name + "=''; expires=" + myDate.toGMTString() + ';path=/'
}

/**
 * @method getQueryString
 * @desc 获取链接参数的值
 * @param url {String} - 链接地址
 * @param name {String} - 参数名称
 * @returns {String} - 参数值
 */
export function getQueryString(url, name) {
  if (!url || !name) return
  return url.match(new RegExp(`(^${name}|[?|&]${name})=([^&#]+)`)) ? RegExp.$2 : ''
}

// 判断移动平台（微信、QQ、微博、QQ空间、UC浏览器）
export function platform(ua = window.navigator.userAgent) {
  let platform

  if (/MicroMessenger/.test(ua)) {
    platform = 'wx'
  } else if (/QQ\//.test(ua)) {
    platform = 'qq'
  } else if (/\bWeibo|__weibo__\d/.test(ua)) {
    platform = 'weibo'
  } else if (/Qzone\//.test(ua)) {
    platform = 'qzone'
  } else if (/UCBrowser/.test(ua)) {
    platform = 'uc'
  } else {
    platform = 'other'
  }

  return platform
}

export function clientType() {
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  if (isIOS) return 'ios'
  const isAndroid = /(Android)/i.test(navigator.userAgent)
  if (isAndroid) return 'android'
  const isMacOS = /macthunder/i.test(navigator.userAgent)
  if (isMacOS) return 'mac'
  return 'pc'
}

/**
 * 随机数产生
 * @param {Number} length - 随机数长度
 * @param {String} [charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'] - 随机数的字符
 * @returns {String} - 随机数
 */
export function random(length, charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
  return Array.apply(null, new Array(length))
    .map(function () {
      return charset.charAt(Math.floor(Math.random() * charset.length))
    })
    .join('')
}

/**
 * 判断所在系统
 * @param {String} [ua = window.navigator.userAgent] - 用户代理
 * @param {String} [pf = window.navigator.platform] - 系统平台类型
 * @returns {String} os - 系统名：'iOS'|'Android'|'Windows Phone'|'macOS'|'Win2000'|'WinXP'|'Win2003'|'WinVista'|'Win7'|'Win10'|'Windows'|'Unix'|'Linux'
 */
export function detectOS(ua = window.navigator.userAgent, pf = window.navigator.platform) {
  let os = ''

  if (/iPhone|iPad|iPod|iOS/.test(ua)) {
    os = 'iOS'
  } else if (/Android/.test(ua)) {
    os = 'android'
  } else if (/\bWindows Phone/.test(ua)) {
    os = 'Windows Phone'
  } else {
    if (pf === 'Mac68K' || pf === 'MacPPC' || pf === 'Macintosh' || pf === 'MacIntel') {
      os = 'macOS'
    } else if (pf === 'Win32' || pf === 'Windows') {
      os = 'Windows'
    } else if (pf === 'X11') {
      os = 'Unix'
    } else if (/Linux/.test(pf)) {
      os = 'Linux'
    }
  }

  return os
}

/**
 * 获取 Min Max 直接的随机数字
 * @param {Number} Min
 * @param {Number} Max
 */
export function getRandomNum(Min, Max) {
  const Range = Max - Min
  const Rand = Math.random()
  return Min + Math.round(Rand * Range)
}

/**
 * base64 编码
 * @param {String} str
 */
export function base64encode(str) {
  const base64EncodeChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  let out, i
  let c1, c2, c3

  const len = str.length
  i = 0
  out = ''
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff
    if (i === len) {
      out += base64EncodeChars.charAt(c1 >> 2)
      out += base64EncodeChars.charAt((c1 & 0x3) << 4)
      out += '=='
      break
    }
    c2 = str.charCodeAt(i++)
    if (i === len) {
      out += base64EncodeChars.charAt(c1 >> 2)
      out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
      out += base64EncodeChars.charAt((c2 & 0xf) << 2)
      out += '='
      break
    }
    c3 = str.charCodeAt(i++)
    out += base64EncodeChars.charAt(c1 >> 2)
    out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4))
    out += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6))
    out += base64EncodeChars.charAt(c3 & 0x3f)
  }
  return out
}

/**
 *
 * @param {Number} bytes 字节数
 * @param {Number} point 小数点保留的位置
 */
export function bytesToSize(bytes, point = 1) {
  if (bytes === 0) {
    return '0B'
  }
  const k = 1024 // or 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const val = bytes / Math.pow(k, i)
  let size = val.toPrecision(3)
  size = val.toFixed(point)
  if (/(.0)/.test(size)) size = size.split('.0')[0]
  return size + sizes[i]
}

/**
 * @method isDebugMode
 * @desc 是否是调试模式
 * @returns {Boolean}
 */
export function isDebugMode() {
  return (
    process.env.NODE_ENV !== 'production' ||
    getQueryString(typeof window !== 'undefined' && window.location.href, 'debug')
  )
}

export function formatTime(dateObj, fmt) {
  const o = {
    'M+': dateObj.getMonth() + 1, // 月份
    'd+': dateObj.getDate(), // 日
    'h+': dateObj.getHours(), // 小时
    'm+': dateObj.getMinutes(), // 分
    's+': dateObj.getSeconds(), // 秒
    'q+': Math.floor((dateObj.getMonth() + 3) / 3), // 季度
    S: dateObj.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, String(dateObj.getFullYear()).substring(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substring(('' + o[k]).length))
    }
  }
  return fmt
}

export function clientToast(message = '未知错误，请稍后再试') {
  window.XLJSWebViewBridge && window.XLJSWebViewBridge.sendMessage('xlShowToast', JSON.stringify({ message }))
}

/** 节流函数 保证在mustRun毫秒内,必然触发一次 handler */
export function throttle(func, wait, mustRun) {
  let timeout
  let startTime = new Date()
  return function () {
    const context = this
    const args = arguments
    const curTime = new Date()
    clearTimeout(timeout)
    if (curTime - startTime >= mustRun) {
      func.apply(context, args)
      startTime = curTime
    } else {
      timeout = setTimeout(func, wait)
    }
  }
}

export function formatSize(size) {
  size = parseInt(size)
  if (!size) {
    return 0
  }
  const sizeMap = ['B', 'KB', 'M', 'G', 'T']
  let index = 0
  let pre = ''
  if (size < 0) {
    // 会有负数的情况
    size = -size
    pre = '-'
  }
  while (size >= 1024) {
    size = size / 1024
    index++
  }
  size = String(size.toFixed(1))
  if (/(.0)/.test(size)) size = size.split('.0')[0]
  return `${pre}${size}${sizeMap[index]}`
}
/**
 * 从客户端内获取用户信息
 */

/**
 *
 *
 * @export
 * @param {number} millisecond 持续时间 ms
 * @returns Promise<void>
 */
export function sleep(millisecond) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, millisecond)
  })
}

// 检测有效的下载链接
export function checkValidLink(url) {
  return /^(thunder|magnet|http[s]?|ftp|ed2k):/i.test(url)
}

// 根据Id来更新树形结构的内容添加新数据
// export function updateListByPropId(id, data = [], nodes) {
//   const newData = [...data]
//   for (const key in data) {
//     if (id === data[key].id) {
//       Vue.set(newData[key], 'nodes', nodes)
//       // 赋值无效，需要子节点都变成可响应式
//       // newData[key].nodes = nodes
//     } else {
//       if (data[key].nodes) {
//         updateListByPropId(id, data[key].nodes, nodes)
//       }
//     }
//   }
//   return newData
// }

// 他人昵称简写
export function shortNickName(str = '', frontLen = 3, endLen = 2) {
  if (str.length <= 1) return str
  else if (str.length === 2) return str.substring(0, 1) + '*'
  else if (str.length === 3) return str.substring(0, 1) + '*' + str.substring(2)
  else if (str.length <= 6) {
    const start = Math.floor(str.length / 2)
    return str.substring(0, start - 1) + '**' + str.substring(str.length - start)
  }
  const start = Array.from({ length: 3 }, () => '*').join('')
  return str.substring(0, frontLen) + start + str.substring(str.length - endLen)
}

export function splitLongText(word, size = 36, row = 1) {
  // const length = word.replace(/[^\x00-\xff]/g,"01").length
  const len = word.length
  const mid = parseInt(size * row * 0.5)
  if (len > size * row) {
    return word.replace(/[\S\s]/gi, (match, index) => {
      if (index > size * row - 8 && index < len - 6) return ''
      else if (index >= mid && index <= mid + 2) return '.'
      else return match
    })
  } else {
    return word
  }
}

export function uuidv4() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// 获取 deviceid
export function getDeviceID() {
  const deviceID = getCookie('deviceid') || uuidv4()
  if (/\./.test(deviceID) && deviceID.length > 32) {
    return deviceID.split('.')[1].slice(0, 32)
  } else {
    return deviceID
  }
}

export function checkIOS() {
  const UA_IOS_REG = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/
  const isIOS13Pad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return UA_IOS_REG.test(navigator.userAgent) || isIOS13Pad
}

export function checkWx() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

export function YYBAppURL(params, route) {
  const protocol = 'xunleiapp'
  params = qs.stringify(params)

  return `${protocol}://${route}?${params}`
}

export function hasClass(obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

export function addClass(obj, cls) {
  if (!hasClass(obj, cls)) obj.className += ' ' + cls
}

export function removeClass(obj, cls) {
  if (hasClass(obj, cls)) {
    let reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    obj.className = obj.className.replace(reg, ' ')
  }
}

export function toggleClass(obj, cls) {
  if (hasClass(obj, cls)) {
    removeClass(obj, cls)
  } else {
    addClass(obj, cls)
  }
}
export const once = fn => {
  let called = false
  return function (...args) {
    if (called) return
    called = true
    return fn.apply(this, args)
  }
}

// 获取文件拓展名
export function getFileExtension(fileName) {
  if (typeof fileName !== 'texting') {
    return ''
  }
  const idx = fileName.lastIndexOf('.')
  return fileName.slice(idx)
}

// pc端获取客户端版本时，格式化参数
export const compileOpts = ({
  secret = '123456', // 默认密钥，跟联盟js跟客户端通信方式一致
  params = {},
} = {}) => {
  let componentParam = ''
  const opts = {}
  Object.entries(params).forEach(item => {
    if (item.length === 2) {
      componentParam += `${item[0]}=${item[1]}`
      opts[item[0]] = decodeURIComponent(item[1])
    }
  })
  componentParam += secret
  return {
    ...opts,
    sign: md5(componentParam),
  }
}

export const callClientByTagA = url => {
  const tagA = document.createElement('a')
  tagA.href = url
  document.body.appendChild(tagA)
  tagA.click()
  document.body.removeChild(tagA)
}
// 下载安卓app
export const downloadAndroidApp = fn => {
  // ios-调起
  if (checkIOS()) {
    callIosApp()
  } else {
    this.$toastMobile.show('安卓版本内测中，敬请期待')
  }
}

export function secondToDate(seconds) {
  const h = Math.floor(seconds / 3600).toString()
  const m = Math.floor((seconds / 60) % 60).toString()
  const s = Math.floor(seconds % 60).toString()
  return `${h.padStart(2, '0')}:${m.padStart(2, '0')}:${s.padStart(2, '0')}`
}

export function TimeNow() {
  return window.performance ? window.performance.now() / 1e3 : Date.now() / 1e3
}

export function fullscreen() {
  const ele = document.documentElement
  if (ele.requestFullscreen) {
    ele.requestFullscreen()
  } else if (ele.mozRequestFullScreen) {
    ele.mozRequestFullScreen()
  } else if (ele.webkitRequestFullScreen) {
    ele.webkitRequestFullScreen()
    // setTimeout(() => {
    //   console.error('fullscreen success')
    //   document.dispatchEvent(new Event('fullscreenchange'))
    // }, 0)
  }
}

export function highlightLink(str) {
  const reg = /(thunder|magnet|http[s]?|ftp|ed2k):[\S]+/gi
  str = str.replace(reg, replacement => {
    return `<em style="color: #3F85FF; word-break: break-all;"
      class="link" data-link=${this.$xss(replacement)}>${replacement}</em>`
  })
  return str
}

export function matchVideoLink(text) {
  let reg = /(thunder|magnet|ed2k):[\S]+/gi
  if (!reg.test(text)) {
    reg = /(ftp|http[s]?):[\S]+[.](mp4|rmvb|m3u8|rm|mkv|avi|wmv|jpg|gif|png|mp3|apk)/g
  }
  return text.match(reg)
}

export function matchValidLink(text) {
  let reg = /(thunder|magnet|ed2k):[\S]+/gi
  if (!reg.test(text)) {
    const ext = exts.join('|')
    reg = new RegExp(`(ftp|http[s]?):[\\S]+[.](${ext})`, 'g')
  }
  return text.match(reg)
}

export function checkValidVideoLink(link) {
  const links = matchVideoLink(link)
  return links && links.length > 0
}

export function checkValidM3u8Link(link) {
  if (/(http[s]?):[\S]+[.](m3u8)/gi.test(link)) return true
  return false
}

export function ellipsisLink(text, maxLen = 44, last = 7) {
  const len = text.length
  const fisrt = text.substring(0, maxLen - last)
  if (len > maxLen) {
    return fisrt + ' ... ' + text.substring(len - last, len)
  } else {
    return text
  }
}

export function highlightVideoLink(text) {
  let reg = /(thunder|magnet|ed2k):[\S]+/gi
  if (!reg.test(text)) {
    reg = /(ftp|http[s]?):[\S]+[.](mp4|rmvb|m3u8|rm|mkv|avi|wmv|jpg|gif|png|mp3|apk)/g
  }
  text = text.replace(reg, replacement => {
    const t = replacement.slice(-7)
    return `<em data-link=${this.$xss(replacement)}>${replacement}</em><span>${t}</span>`
  })
  return text
}

export function matchLink(text) {
  const reg = /(thunder|magnet|http[s]?|ftp|ed2k):[\S]+/gi
  return text.match(reg)
}

export function highlightXlPwd(text) {
  const reg = /【迅雷口令#X([\S]+)#】[\S]+/gi
  text = text.replace(reg, replacement => {
    return `<em style="color: #3F85FF; word-break: break-all; text-decoration: underline;"
      class="xlPwd" data-pwd=${this.$xss(replacement)}>${replacement}</em>`
  })
  return text
}

// 判断是否为mac迅雷客户端内嵌页面
export function checkMacThunder() {
  return /MacThunder/i.test(navigator.userAgent)
}

export function formatNoteTime(time) {
  time = time.replace(/\-/g, '/')
  const span24 = 24 * 60 * 60 * 1000
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const day = now.getDate()
  const today = `${year}/${month}/${day}`
  const todayTime = new Date(today).getTime()
  const yesterdayTime = new Date(todayTime - span24).getTime()

  const cTime = new Date(time)
  const cYear = cTime.getFullYear()
  const cMonth = cTime.getMonth() + 1 < 10 ? `0${cTime.getMonth() + 1}` : cTime.getMonth() + 1
  const cDay = cTime.getDate() < 10 ? `0${cTime.getDate()}` : cTime.getDate()
  const cHour = cTime.getHours() < 10 ? `0${cTime.getHours()}` : cTime.getHours()
  const cMiniute = cTime.getMinutes() < 10 ? `0${cTime.getMinutes()}` : cTime.getMinutes()

  const timeSpan = now.getTime() - cTime.getTime()
  if (timeSpan < 3 * 60 * 1000) {
    return '刚刚存入'
  }

  if (cTime >= todayTime) {
    return `今天 ${cHour}:${cMiniute}`
  } else if (cTime < todayTime && yesterdayTime <= cTime) {
    return `昨天 ${cHour}:${cMiniute}`
  } else {
    if (cYear < year) {
      return `${cYear}-${cMonth}-${cDay} ${cHour}:${cMiniute}`
    }
    return `${cMonth}-${cDay} ${cHour}:${cMiniute}`
  }
}

/**
 * @description 交叉合并两个数组,以小数组开头交叉合并，最后再合并大数组剩下的
 * @param {array} a 数组一
 * @param {array} b 数组二
 * @returns {array} 合并后的数组
 */
export function concatCrossArray(a, b) {
  if (a.length === 0 || b.length === 0) return [...a, ...b]
  let maxArr = []
  let minArr = []
  if (a.length > b.length) {
    maxArr = a
    minArr = b
  } else {
    maxArr = b
    minArr = a
  }
  const arr = []
  minArr.forEach((v, i) => {
    arr.push(v)
    arr.push(maxArr[i])
  })
  return [...arr, ...maxArr.slice(minArr.length)]
}

/**
 * @description 懒加载三方的js库，方便在组件内使用
 * @param {src} 链接地址
 * @param {async} 是否是async模式
 * @param {options} 其他配置参数
 */
export function loadJsAsync(src, async = true, options = null) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = async
    if (options) {
      for (const key in options) {
        script.setAttribute(key, options[key])
      }
    }

    const onload = () => {
      script.removeEventListener('load', onload)

      resolve()
    }

    script.addEventListener('load', onload)
    script.addEventListener('error', err => {
      script.removeEventListener('load', onload)
      reject(new Error(`Failed to load ${src}`))
    })
    ;(document.getElementsByTagName('head')[0] || document.documentElement).appendChild(script)
  })
}

//消除js计算误差num1、num2是传入的加减数字,reduce是被加数（被减数），s 是加减符号, len 为精度长度: https://juejin.cn/post/7065506610105286670
export function calculateNum(num1, num2, method, len) {
  const m = Math.pow(10, len) // len是10的次幂
  let res = method == '+' ? (num1 * m + num2 * m) / m : (num1 * m - num2 * m) / m
  return Math.round(res * m) / m
}
export function pubevHI5Px9f3KdFtJtko6WIiVPPvQIwPDD (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'LSZbJ5RRu2lmnB4e', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./error-message.js').pubQOBjKdtga40kM0XKyVFLoW1f7psopFsP
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubN1vh52BJ0MjWtSLwTvX6IDuUss6WJLPT (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./drive-util.js').pubdWReaLIsMTCtSYXo7wZ4IKlWK6FD3xRl
            const nextPart2 = require('./static-icons.js').pubq7qJaPz75e1Iifu9fDFBYSduFy2P8wlk
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubacHVzEBoOmBSBxsFMquhXzzEyiICyCm5 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'dKXkuBS13y1NAb', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./stat.js').pubNndTwUZV2NQAFV8oNkb8gUfyyJ4t64sy
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubLKU8HAmU2mgIFJDnQRmTKk48oVL0cZND (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'hZeAm1izd15rHPMXMBYBqBQq1TRXto+OOO4ewGDuBC', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./error-message.js').pubblsyfmBNwArv1GWoNrcAhSXs6tuPqor0
              return nextPart1(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }export function pubGiJyt0zM3fG6uzEG3aFj5LOzpt8qNBGh (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'qvoSIDmnoqRgQA', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./get-user-info.js').pubqhEEF96c5iRMmoLYu5ptjxqycE4IjYSR
              const nextPart2 = require('./error-message.js').pubQOBjKdtga40kM0XKyVFLoW1f7psopFsP
              return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }